import { layout } from '../../App.routing'

export const foodAndDrinkSegment = layout.nestedComposition({
    type: 'janus',
    props: {
        stretchColumns: true,
        verticalSpacing: 'lg',
        hasBorder: true,
    },
    contentAreas: {
        left: [
            layout.component({
                type: 'lima',
                props: {
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'food',
                        offset: 0,
                        pageSize: 4,
                    },
                    sectionHeader: {
                        heading: 'Food',
                        headingUrl: '/lifestyle/food',
                    },
                    verticalSpacing: 'xs',
                    fixedRatios: ['16:9'],
                    finalColumns: 2,
                    stretchSelf: true,
                    hasBorder: false,
                    cardLayout: [
                        ['teaserWithBackground'],
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                        ],
                    ],
                    cardOrientation: {
                        type: 'Landscape-Portrait',
                    },
                },
            }),
        ],
        right: [
            layout.component({
                type: 'lima',
                props: {
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'drink',
                        offset: 0,
                        pageSize: 4,
                    },
                    sectionHeader: {
                        heading: 'Drink',
                        headingUrl: '/lifestyle/drink',
                    },
                    verticalSpacing: 'xs',
                    fixedRatios: ['16:9'],
                    finalColumns: 2,
                    stretchSelf: true,
                    hasBorder: false,
                    cardLayout: [
                        ['teaserWithBackground'],
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-smTeaser-mdNoTeaser',
                            },
                        ],
                    ],
                    cardOrientation: {
                        type: 'Landscape-Portrait',
                    },
                },
            }),
        ],
    },
})
